import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import { SEARCH_QUERY_URL_PARAM } from '~/screens/GlobalSearchScreen/constants';

import { HighlightSearchTerm } from './HighlightSearchTerm';

interface Props {
  children: React.ReactNode;
  query?: string;
  enableHighlighting?: boolean;
}

export const HighlightSearchTermContainer: React.FC<Props> = ({
  children,
  query,
  enableHighlighting = true,
}) => {
  const { isEnabled: isFoamGlobalSearchEnabled } = useFeature(
    FEATURE_FLAGS.foamGlobalSearch,
  );

  // To get the search query param from the global search
  // and use it to highlight the search query in the right fields
  const params = new URLSearchParams(document.location.search);
  const searchQueryParam = decodeURIComponent(
    params.get(SEARCH_QUERY_URL_PARAM) ?? '',
  );

  // Use provided query if available, otherwise fallback to URL parameter
  const searchQuery = query || searchQueryParam;

  return isFoamGlobalSearchEnabled && searchQuery && enableHighlighting ? (
    <HighlightSearchTerm query={searchQuery}>{children}</HighlightSearchTerm>
  ) : (
    <>{children}</>
  );
};
